import React from "react";
import axiosInstance from "../services/AxiosInstance";
import styles from "./css/UserStory.module.css";
import { RouteComponentProps, withRouter } from "react-router-dom";
import ActivityIndicator from "../components/ActivityIndicator";
import { IonContent, IonHeader, IonPage, IonToolbar, IonAlert } from "@ionic/react";

interface UserStoryProps extends RouteComponentProps {
  // Define props here
}

interface UserStoryState {
  // Define state here
}

class UserStory extends React.Component<UserStoryProps, UserStoryState> {
  state = {
    questionsAndAnswers: [
      {
        question: "",
        questionId: 0,
        answers: [],
        hasImage: false,
        imageUrl: ""
      },
    ],

    AmountOfQuestions: 0,
    hasQuestions: false,
    index: 1,
    subjectId: 0,
    challengeId: 0,
    score: 0,

    goBack: false,
    hasError: false,

    isFirstPart: true,
    isLastChallenge: false,
    userChallengeId: 0,

    // prop pass to moodQuestion.tsx //
    moodQuestionList: [{
      moodQuestion: "",
      questionId: 0
    }],
  };

  constructor(props: UserStoryProps) {
    super(props);
    this.getStateValues();
  }

  componentDidMount() {
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", this.onBrowserBackEvent)
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.onBrowserBackEvent)
  }

  onBrowserBackEvent = () => {
    window.history.pushState(null, "", window.location.href);
    this.setState({ goBack: true })
  }

  async getStateValues() {

    this.state.index = Number(localStorage.getItem("index"));
    this.state.challengeId = Number(localStorage.getItem("challengeId"));
    this.state.score = Number(localStorage.getItem("score"));
    this.state.userChallengeId = Number(localStorage.getItem("userChallengeId"));
    this.state.moodQuestionList = JSON.parse(localStorage.getItem("moodQuestionList") as string);

    let isFirstPart = localStorage.getItem("isFirstPart");
    if (isFirstPart === "true") {
      this.state.isFirstPart = true
    } else {
      this.state.isFirstPart = false
    }

    let isLastChallenge = localStorage.getItem("isLastChallenge");
    if (isLastChallenge === "true") {
      this.state.isLastChallenge = true
    } else {
      this.state.isLastChallenge = false
    }

    this.setState({ state: this.state });

    this.getQuestiondata();
  }

  async goBackHandler() {
    var token = localStorage.getItem("token");
    var employeeId = localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const { history } = this.props;

    axiosInstance.post(
      "/Results",
      {
        score: -1,
        selfEvaluationScore: -1,
        challengeId: this.state.challengeId,
        employeeId: employeeId,
      },
      config
    );

    await axiosInstance
      .put(
        "/UserChallenges/" + this.state.userChallengeId,
        {
          id: this.state.userChallengeId,
          userId: employeeId,
          challengeId: this.state.challengeId,
          isFinished: true,
        },
        config
      )
      .catch((error) => {
        console.log(error);
      });

    if (this.state.isLastChallenge) {
      await axiosInstance
        .put(
          "/UserSubjects/" + localStorage.getItem("userSubjectId"),
          {
            id: localStorage.getItem("userSubjectId"),
            userId: employeeId,
            subjectId: localStorage.getItem("subjectId"),
            isFinished: true,
          },
          config
        )
        .catch((error) => {
          console.log(error);
        });
      localStorage.setItem('reloadCount', String(1));
      history.push("/portal");
    } else {
      localStorage.setItem('reloadCount', String(1));
      history.push("/Case", { currentChallengeIsFinished: true });
    }
  }

  async getQuestiondata() {
    var id = localStorage.getItem("id");
    var token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axiosInstance
      .get("/Challenges/" + this.state.challengeId, config)
      .then((response) => {
        //console.log(response.data)
        response.data.questions.forEach((question: any) => {
          if (question.fileName == null) {
            this.state.questionsAndAnswers.push({
              question: question.questionText,
              questionId: question.id,
              answers: question.answers,
              hasImage: false,
              imageUrl: ""
            })
          } else {
            this.state.questionsAndAnswers.push({
              question: question.questionText,
              questionId: question.id,
              answers: question.answers,
              hasImage: true,
              imageUrl: question.url
            })
          }
        });

        this.state.hasQuestions = true;

        this.state.AmountOfQuestions =
          this.state.questionsAndAnswers.length - 1;

        this.setState({ state: this.state });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ hasError: true });
      });
  }

  async pressAction(id: number, correct: boolean, questionId: number) {

    var token = localStorage.getItem("token");
    var employeeId = localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axiosInstance
      .post(
        "/SelectedAnswers",
        {
          answerId: id,
          employeeId: employeeId,
          questionId: questionId,
          challengeId: this.state.challengeId,
        },
        config
      )
      .then(async (res) => {
        if (correct === true) {
          this.state.score += 1;
        }

        if (this.state.isFirstPart) {
          // emotionele vraag op een random moment tijdens de quiz
          let questionsBeforeMood = Math.floor(Math.random() * this.state.AmountOfQuestions);

          if (questionsBeforeMood > this.state.index) {
            this.state.index += 1;
          } else {
            localStorage.setItem("moodQuestionIndex", "" + 1)
            localStorage.setItem("index", "" + (this.state.index + 1))
            localStorage.setItem("score", "" + this.state.score)
            localStorage.setItem("isFirstPart", "" + false)

            localStorage.setItem("reloadCount", String(1)) // refresh mood question page //
            this.props.history.push("/MoodQuestion")
          }

        } else {
          if (this.state.AmountOfQuestions > this.state.index) {
            this.state.index += 1
          } else {
            await this.postResult(this.state.score);

            localStorage.setItem("aantalVragen", "" + this.state.AmountOfQuestions)
            localStorage.setItem("score", "" + this.state.score)

            this.props.history.push("/Evaluation")
          };
        }

        this.setState({ state: this.state });
      })
      .catch((error) => {
        console.log(error);
      });

  }

  async postResult(score: number) {
    var token = localStorage.getItem("token");
    var employeeId = localStorage.getItem("id");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axiosInstance.post(
      "/Results", {
      score: score,
      challengeId: this.state.challengeId,
      employeeId: employeeId,
    },
      config
    )
      .then((error) => {
        console.log(error)
      });

    this.setState({ state: this.state })
  }


  render() {
    let qA = this.state.hasError ? (
      <div style={{ margin: "auto", textAlign: "center", padding: "2rem" }}>
        <p style={{ fontWeight: "bold", marginBottom: "1rem" }}>Er is iets fout gelopen bij het laden van de vragen.</p>
        <button
          onClick={() => { this.setState({ hasError: false }); this.getQuestiondata(); }}
          style={{ padding: "0.75rem 1.5rem", backgroundColor: "#5094B9", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", marginBottom: "1rem", width: "100%" }}
        >
          Probeer opnieuw
        </button>
        <button
          onClick={() => this.props.history.goBack()}
          style={{ padding: "0.75rem 1.5rem", backgroundColor: "transparent", color: "#5094B9", border: "2px solid #5094B9", borderRadius: "6px", cursor: "pointer", width: "100%" }}
        >
          Ga terug
        </button>
      </div>
    ) : this.state.hasQuestions ? (
      <>
        <div className={(styles.schermdeel)}>
          <p className={`${styles.titleText} ${styles.textFontBold}`}>
            Vraag {this.state.index}:
          </p>
          <p className={`${styles.questionText} ${styles.textFont}`}>
            {this.state.questionsAndAnswers[this.state.index].question}
          </p>
          {this.state.questionsAndAnswers[this.state.index].hasImage &&
            <figure className={styles.image}>
              <img src={this.state.questionsAndAnswers[this.state.index].imageUrl} />
            </figure>}
        </div>

        <div style={{ marginTop: "10vh" }}>
          {this.state.questionsAndAnswers[this.state.index].answers.map((answer: any) => (
            <div
              key={answer.id}
              className={(styles.button)}
              onClick={() =>
                this.pressAction(answer.id, answer.correctAnswer, answer.questionId)}
            >
              <p className={(styles.answerText)}>
                {answer.possibleAnswer}
              </p>
            </div>
          ))}
        </div>
      </>
    ) : (
      <div style={{ margin: "auto", width: "100%", height: "100%" }}>
        <ActivityIndicator />
      </div>
    )

    return (
      <IonPage ion-no-header="true">
        <IonHeader class="ion-no-border">
          <IonToolbar>
            <button className="backButton" onClick={() => { this.setState({ goBack: true }) }}>&larr;</button>
          </IonToolbar>
        </IonHeader>
        <IonAlert
          isOpen={this.state.goBack}
          header="Pas op!"
          message="Bij terugkeren of afsluiten zal de challenge worden verzonden met een 0-score"
          buttons={[
            {
              text: "Annuleer",
              handler: () => { this.setState({ goBack: false }) }
            },
            {
              text: "Oké",
              handler: () => this.goBackHandler()
            }
          ]}
        />
        <IonContent fullscreen>
          <div>
            {qA}
          </div>
        </IonContent>
      </IonPage>
    );
  }
}
export default withRouter(UserStory);
